import { useMemo } from 'react'

export function useDependency<T>(value: T) {
  return useMemo(() => {
    if (!value) {
      return
    }
    if (value instanceof Set) {
      return JSON.stringify([...value])
    }
    if (Array.isArray(value)) {
      return JSON.stringify(value)
    }
    if (value && typeof value === 'object') {
      return JSON.stringify(value)
    }
    return String(value)
  }, [value])
}
